import React from "react";

export default function InfoCard({
  title,
  description,
  icon,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
}) {
  return (
    <div className="min-h-64 bg-white border shadow-lg flex items-start space-y-6 flex-col w-full h-auto p-6   rounded-xl">
      {icon}

      <h2 className="text-xl font-bold text-zinc-700">{title}</h2>

      <p className="text-zinc-500 text-sm">{description}</p>
    </div>
  );
}
